export default "__VITE_ASSET__DOMsGMXt__"